import { Divider } from '@mui/material';
import ChartSection from 'src/components/dashboardComponents/ChartSection';
import InventorySection from 'src/components/dashboardComponents/InventorySection';
import OrderSection from 'src/components/dashboardComponents/orderSection';
import RevenueSection from 'src/components/dashboardComponents/RevenueSection';

export default function CEODashboard() {
  return (
    <>
      <RevenueSection />
      <Divider sx={{ mb: 4 }} />
      <InventorySection />
      <Divider sx={{ mb: 4 }} />
      <OrderSection />
      <Divider sx={{ mb: 4 }} />
      <ChartSection />
    </>
  );
}
